export const ApprovalStepStatus = {
  APPROVAL_PENDING: 'APPROVAL_PENDING',
  APPROVED: 'APPROVED',
  CHANGES_REQUESTED: 'CHANGES_REQUESTED',
  REJECTED: 'REJECTED',
  WAITING: 'WAITING'
};
export const AgentTurnType = {
  REVIEW: 'REVIEW',
  APPLY_CHANGES: 'APPLY_CHANGES'
};